import React, { useState } from 'react';

const initForm = initialValues => {
  const result = Object.keys(initialValues || {}).reduce(
    (acc, name) => {
      acc.metas[name] = { valid: true, touched: false };
      return acc;
    },
    {
      values: { ...initialValues },
      metas: {},
      submitted: false,
      submitting: false
    }
  );
  return result;
};

const Form = ({ initialValues, validate, onSubmit, children }) => {
  const [form, setForm] = useState(initForm(initialValues));
  const { values, metas, submitting } = form;
  const setSubmitting = submitting => {
    setForm({
      ...form,
      submitting: !!submitting
    });
  };
  const onChange = evt => {
    const { name, value } = evt.target;
    if (metas[name].touched) {
      const validations = validate(form.values);
      validations[name].touched = true;
      setForm({
        ...form,
        values: { ...form.values, [name]: value },
        metas: { ...form.metas, [name]: validations[name] }
      });
    } else {
      setForm({ ...form, values: { ...form.values, [name]: value } });
    }
  };

  const onBlur = evt => {
    const { name, value } = evt.target;
    if (form.submitted) {
      const validations = validate(form.values);
      validations[name].touched = true;
      setForm({
        ...form,
        values: { ...form.values, [name]: value },
        metas: { ...form.metas, [name]: validations[name] }
      });
    } else {
      setForm({
        ...form,
        values: { ...form.values, [name]: value }
      });
    }
  };

  const doSubmit = evt => {
    evt.preventDefault();
    const validations = validate(form.values);
    const { valid, metas } = Object.keys(validations).reduce(
      (acc, key) => {
        validations[key].touched = true;
        return {
          valid: acc.valid && validations[key].valid,
          metas: validations
        };
      },
      { valid: true, metas: validations }
    );
    setForm({
      ...form,
      submitted: true,
      metas: { ...form.metas, ...metas }
    });

    if (valid && submitting === false) {
      onSubmit(form.values, { setSubmitting }, evt);
    }
  };

  return (
    <FormContext.Provider value={{ values, metas, onChange, onBlur, doSubmit }}>
      {children({ values, metas, onChange, onBlur, doSubmit, submitting })}
    </FormContext.Provider>
  );
};

const FormContext = React.createContext();

export default Form;
export { FormContext };
